export default {
    hello: "Hello {name}",
}